export const nameRegex = /^[a-zA-Z'-]+$/g;
export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

export const isValidName = (name) => {
    return name.match(nameRegex);
};

export const isValidEmail = (email) => {
    return email.match(emailRegex);
};

export const isValidPhone = (phone) => {
    return phone.match(phoneRegex);
};

export function clean(val) {
    val = val.replace(/{/, '');
    val = val.replace(/"/, '');
    val = val.replace(/"/, '');
    val = val.replace(/}/, '');

    return val;
}

const errors = {
    uppercase: { regex: /[A-Z]/, description: 'At least one uppercase letter' },
    lowercase: { regex: /[a-z]/, description: 'At least one lowercase letter' },
    digit: { regex: /[0-9]/, description: 'At least one digit' },
    special: { regex: /[^A-Za-z0-9]/, description: 'At least one special symbol' },
    length: { test: e => e.length > 8, description: 'Must be 9 characters or more' },
 };
 
export const checkPasswordComplexity = (password) =>{
    return Object.entries(errors).flatMap(([name, { test, regex, description }]) => {
        const isValid = test ? test(password) : regex.test(password);
        return isValid ? [] : { description, name };
      });
}